import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Badge } from 'primereact/badge';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { TabMenu } from 'primereact/tabmenu';
import { MenuItem } from 'primereact/menuitem';

// Column
import { FreshApplicationOtherPaymentDoneColumns, FreshApplicationOtherPaymentPendingColumns } from '../../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries, freshApplicationOtherStateName, PreOtherStatusOptions } from '../../../appconfig/Settings';

//Services
import { deleteDataWithMultipleParameters, getAllDetails, postAllData } from '../../../service/ProductService';
import moment from 'moment';
import { DELETE_PRE_APPLICATION, DELETE_REFUND, GET_APPLICATIONLIST } from '../../../config/ApiConstant';
import { ApplicationTab } from '../applicationTab';
import { FreshApplicationTab } from './FreahApplicationTab';
import { applicationsAppointmentDateTemplate, applicationsDOBTemplate, applicationsFullNameTemplate, collegeNameTemplate, joiningYearTemplate, passingYearTemplate, payDtTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { checkEmail, checkEmailPreApplication, setAppStatus } from '../../../appconfig/AppHelper';
import { NavLink } from 'react-router-dom';
import { Avatar } from 'primereact/avatar';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';

export const FreshApplicationOther = () => {
    document.title = 'Fresh Application Other | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);
    const [searchVal, setSearchVal] = useState<any>(null);

    // Date Object
    const storedDates = localStorage.getItem('fresh_other_app');
    let initialStartDate = moment().subtract(30, 'days').toDate();
    let initialEndDate = moment().toDate();

    if (storedDates) {
        try {
            const parsed = JSON.parse(storedDates);
            initialStartDate = parsed.startDate ? new Date(parsed.startDate) : initialStartDate;
            initialEndDate = parsed.endDate ? new Date(parsed.endDate) : initialEndDate;
        } catch (error) {
            console.error('Error parsing stored dates', error);
        }
    }

    const [dates, setDates] = useState({
        start: initialStartDate,
        end: initialEndDate
    });

    // Navigate
    const navigate = useNavigate();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [applicationsList, setApplicationsList] = useState<any>([]);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteBillSrNo, setDeleteBillSrNo] = useState<any>(null);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [appStatusFilter, setAppStatusFilter] = useState<any>({ name: 'All', code: 'All' });
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [isEmail, setIsEmail] = useState<boolean>(false);
    const [isPreEmail, setPreIsEmail] = useState<boolean>(false);
    const Tabitems: MenuItem[] = [
        {
            label: 'Pre Register'
        },
        {
            label: 'Post Register'
        }
    ];

    // useEffect
    useEffect(() => {
        getApplicationsList();

        //check mail for refund
        const mail = checkEmail(localStorage.getItem('email'));
        if (mail) {
            setIsEmail(true);
        }

        //check pre  email for delete application
        const preEmail = checkEmailPreApplication(localStorage.getItem('email'));
        if (preEmail) {
            setPreIsEmail(true);
        }

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [dates, activeIndex]);

    // On Date Change
    const onDateChange = (start: any, end: any) => {
        setDates({ start, end });

        if (start && end) {
            localStorage.setItem(
                'fresh_other_app',
                JSON.stringify({
                    startDate: moment(start).format('YYYY-MM-DD'),
                    endDate: moment(end).format('YYYY-MM-DD')
                })
            );
        }
    };

    // Get applications list from api
    const getApplicationsList = async () => {
        try {
            setPageLoad(false);
            let selectedTab = 'payment_pending';
            if (activeIndex === 1) {
                selectedTab = 'payment_done';
            }

            let startDate = moment(dates?.start).format('y-M-D') + ' 00:00:00';
            let endDate = moment(dates?.end).format('y-M-D') + ' 23:59:59';

            const response = await getAllDetails(GET_APPLICATIONLIST + '?AppNm=' + freshApplicationOtherStateName + '&start_date=' + startDate + '&end_date=' + endDate + '&search=' + searchVal + '&tab_type=' + selectedTab);
            if (response) {
                const DataList: any = response;

                if (DataList.length === 0) {
                    setApplicationsList([]);
                } else {
                    setApplicationsList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setApplicationsList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setApplicationsList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="block mt-2 md:mt-0 p-input-icon-left mr-3">
                    <i className="pi pi-search"></i>
                    <InputText value={searchVal} onChange={(e) => setSearchVal(e.target.value)} placeholder="Search..." className="" />
                    <i className="pi pi-times input-s" onClick={() => removeSearch()} style={{ right: '10px', zIndex: '111111', cursor: 'pointer' }}></i>
                </span>

                <Button label="" icon="pi pi-search" className="p-button p-button-rounded" onClick={() => getApplicationsList()} />
            </>
        );
    };

    const removeSearch = () => {
        setSearchVal(null);
        setGlobalFilter(null);
        getApplicationsList();
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <CustomDatePicker startDate={dates.start} endDate={dates.end} onChange={onDateChange} />
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // On row select action
    const onRowSelection = (value: any) => {
        navigate('/app/application/applicationViewForm/' + btoa(value.SrNo));
    };

    // Open delete with refund modal
    const openDeleteWithRefundModal = (id: any, billSrNo: any = null) => {
        setDeleteId(id);
        setDeleteBillSrNo(billSrNo);
        setDeleteModal(true);
    };

    // Close delete with refund modal
    const closeDeleteWithRefundModal = () => {
        setDeleteId(null);
        setDeleteBillSrNo(null);
        setDeleteLoader(false);
        setDeleteModal(false);
    };

    // Template for actions
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="View" tooltipOptions={{ position: 'top' }} icon="pi pi-eye" onClick={() => navigate('/app/application/applicationViewForm/' + btoa(rowData.SrNo))} />

                    {activeIndex === 1 && isEmail === true && (
                        <Button icon="pi pi-trash" tooltip="Delete With Refund" tooltipOptions={{ position: 'top' }} className="p-button-danger ml-2" onClick={() => openDeleteWithRefundModal(rowData.SrNo, rowData?.BillSrNo)} />
                    )}

                    {activeIndex === 0 && isPreEmail === true && <Button icon="pi pi-trash" tooltip="Delete Application" tooltipOptions={{ position: 'top' }} className="p-button-danger ml-2" onClick={() => openDeleteWithRefundModal(rowData.SrNo)} />}
                </div>
            </>
        );
    };

    // Search by app status
    const searchByAppStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={PreOtherStatusOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    // Template for status
    const statusTemplate = (rowData: any) => {
        let appStatusVal = setAppStatus(rowData.appStatus);
        return (
            <div className="text-center">
                <Badge severity={appStatusVal.severity} value={appStatusVal.value}></Badge>
            </div>
        );
    };

    //Name Template
    const applicationsNameTemplate = (rowData: any) => {
        return (
            <>
                <NavLink to={`/app/application/applicationViewForm/${btoa(rowData.SrNo)}`}>
                    <div className="avatar-div flex align-items-center">
                        {!window.cn(rowData?.Image) ? <Avatar image={rowData?.Image} shape="circle" /> : <Avatar icon="pi pi-user" shape="circle" />}
                        <div className="emp-name link-name ml-2">{rowData?.full_name}</div>
                    </div>
                </NavLink>
            </>
        );
    };

    // Template for comment
    const commentTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                {rowData.appStatus === 'Rejected' || rowData.appStatus === 'Hold' ? (
                    <Button tooltip={rowData?.comment} className="p-button-custom-tooltip" tooltipOptions={{ position: 'top' }}>
                        <div className="college-name-div">{rowData?.comment}</div>
                    </Button>
                ) : (
                    '-'
                )}
            </>
        );
    };

    // Delete Application Api call
    const deleteAppApiCall = async () => {
        try {
            setDeleteLoader(true);
            let response;
            // Delete api call
            if (activeIndex === 1) {
                response = await deleteDataWithMultipleParameters(DELETE_REFUND + '?sr_no=' + deleteId + '&app_name=' + freshApplicationOtherStateName + '&transaction_id=' + deleteBillSrNo);
            } else {
                let formData: any = new FormData();
                formData.append('sr_no', deleteId);
                formData.append('app_name', freshApplicationOtherStateName);
                response = await postAllData(DELETE_PRE_APPLICATION, formData);
            }
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                setDeleteBillSrNo(null);
                getApplicationsList();
            } else {
                setPageLoad(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    return (
        <>
            <ApplicationTab mainTabLabel="Fresh Application" />
            <FreshApplicationTab initialTabLabel="Fresh Registration Other" />
            <Toast ref={toast} />

            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <TabMenu model={Tabitems} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="general-tab inner-tab fresh-other-tab" />
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>

                        {/* Datatable */}
                        {activeIndex === 0 ? (
                            <>
                                {pageLoad ? (
                                    <>
                                        <DataTable
                                            value={applicationsList}
                                            showGridlines
                                            stripedRows
                                            globalFilter={globalFilter}
                                            filters={globalFieldFilter}
                                            rows={defaultRowOptions}
                                            paginator={applicationsList.length >= 10 && true}
                                            rowsPerPageOptions={defaultPageRowOptions}
                                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                            className="datatable-responsive p-datatable-sm"
                                            emptyMessage="No Applications Found"
                                            paginatorTemplate={paginatorLinks}
                                            currentPageReportTemplate={showingEntries}
                                        >
                                            {FreshApplicationOtherPaymentPendingColumns.map((col, i) => {
                                                if (col.field === 'appStatus') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByAppStatus} style={{ minWidth: '13rem' }} />;
                                                } else if (col.field === 'pendingaction') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                                } else if (col.field === 'full_name') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={applicationsNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                } else if (col.field === 'BOD') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={applicationsDOBTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'JoingYth') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={joiningYearTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'Passedyth') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={passingYearTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'ColName') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={collegeNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                } else if (col.field === 'SrNo') {
                                                    return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '7rem' }} />;
                                                } else {
                                                    return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                                }
                                            })}
                                        </DataTable>
                                        {/* <Paginator first={first} rows={perPage} totalRecords={totalRecords} rowsPerPageOptions={defaultPageRowOptions} onPageChange={onPageChange} /> */}
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton Data table */}
                                        <DataTable value={Skeletonitems}>
                                            {FreshApplicationOtherPaymentPendingColumns.map((col, i) => (
                                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                            ))}
                                        </DataTable>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                {pageLoad ? (
                                    <>
                                        <DataTable
                                            value={applicationsList}
                                            showGridlines
                                            stripedRows
                                            globalFilter={globalFilter}
                                            filters={globalFieldFilter}
                                            rows={defaultRowOptions}
                                            paginator={applicationsList.length >= 10 && true}
                                            rowsPerPageOptions={defaultPageRowOptions}
                                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                            className="datatable-responsive p-datatable-sm"
                                            emptyMessage="No Applications Found"
                                            selectionMode="single"
                                            paginatorTemplate={paginatorLinks}
                                            currentPageReportTemplate={showingEntries}
                                            onSelectionChange={(e) => onRowSelection(e.value)}
                                            removableSort
                                        >
                                            {FreshApplicationOtherPaymentDoneColumns.map((col, i) => {
                                                if (col.field === 'action') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                                } else if (col.field === 'slot_data.slot_details.date') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={applicationsAppointmentDateTemplate} sortable />;
                                                } else if (col.field === 'appStatus') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} filter filterElement={searchByAppStatus} />;
                                                } else if (col.field === 'PayDt') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={payDtTemplate} sortable style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'BOD') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={applicationsDOBTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'JoingYth') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={joiningYearTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'Passedyth') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={passingYearTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'full_name') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={applicationsFullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                } else if (col.field === 'ColName') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={collegeNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                } else if (col.field === 'SrNo') {
                                                    return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} style={{ minWidth: '7rem' }} />;
                                                } else {
                                                    return <Column key={col.field} field={col.field} header={col.header} filter filterPlaceholder={'Search by ' + col.header} />;
                                                }
                                            })}
                                        </DataTable>
                                        {/* <Paginator first={first} rows={perPage} totalRecords={totalRecords} rowsPerPageOptions={defaultPageRowOptions} onPageChange={onPageChange} /> */}
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton Data table */}
                                        <DataTable value={Skeletonitems}>
                                            {FreshApplicationOtherPaymentDoneColumns.map((col, i) => (
                                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                            ))}
                                        </DataTable>
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Delete With Refund Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete Application"
                modal
                footer={
                    <>
                        <Button label="Cancel" className="p-button-secondary" onClick={closeDeleteWithRefundModal} />
                        <Button label="Delete With Refund" className="p-button-danger" onClick={deleteAppApiCall} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteWithRefundModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this Application, This will be deleted permanently.</span>
                </div>
            </Dialog>
        </>
    );
};
